export const getLineClampStyle = (lines: number): React.CSSProperties => ({
  overflow: "hidden",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: lines,
});

export const getDescriptionStyle = (isTwoLines: boolean) =>
  getLineClampStyle(isTwoLines ? 1 : 2);

export const calculateTitleLineCounts = (
  refs: React.MutableRefObject<(HTMLElement | null)[]>
) => {
  if (refs.current && refs.current.length > 0) {
    const lineCounts = refs.current.map((ref) => {
      if (ref) {
        const lineHeight = parseFloat(getComputedStyle(ref).lineHeight);
        const titleHeight = ref.offsetHeight;
        const numberOfLines = titleHeight / lineHeight;
        return numberOfLines > 1;
      }
      return false;
    });
    return lineCounts;
  }
  return [];
};
